import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  LocalDateTimePicker,
  LocalDateTimePickerSchema,
} from './LocalDateTimePicker';

export const LocalDateTimePickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'LocalDateTimePicker',
    component: LocalDateTimePicker,
    schema: LocalDateTimePickerSchema,
  }),
);
